<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-row dense justify="center">
            <v-col cols="12" sm="2" md="2">
                <v-icon color="error" class="no-display">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required outlined return-object v-model="sel_ay_data"
                    :items="ay_std_div_list" item-text="ay" label="Select Academic Year" persistent-hint
                    hint="Please select academic year" @change="getStd" />
            </v-col>

            <v-col cols="12" sm="2" md="2">
                <v-icon color="error" class="no-display">*</v-icon>
                <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                    item-text="display_name" item-value="id" label="Semester" persistent-hint
                    hint="Please select semester" />
            </v-col>

            <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                <v-icon color="error" class="no-display">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required outlined return-object v-model="sel_std_data"
                    :items="std_div_list" item-text="std" label="Standard" persistent-hint hint="Please select standard"
                    @change="getDiv" />
            </v-col>

            <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                <v-icon color="error" class="no-display">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required outlined v-model="div" :items="div_list"
                    item-text="div_name" item-value="div_off_id" label="Division" persistent-hint
                    hint="Please select division" />
            </v-col>

            <v-col cols="12" sm="2" md="2">
                <v-icon color="error" class="no-display">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required outlined v-model="status" :items="status_list"
                    item-text="name" item-value="id" label="Status" persistent-hint hint="Select Status" />
            </v-col>

            <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && sem">
                <v-btn class="mt-6 button" :loading="fetch_loader" @click="getReport">
                    Fetch
                </v-btn>
            </v-col>
        </v-row>
        <br>

        <div id="my-table-id" v-if="report_list.length > 0">
            <div class="report-header">

                <div class="logo-section">
                    <img :src="org_basic_data.school_logo" alt="School Logo" class="school-logo" />
                </div>

                <div class="header-content text-center">
                    <h2>
                        Subject Wise Pass/Fail Analysis Report
                    </h2>

                    <h4>
                        {{ org_basic_data.trust_name }}
                    </h4>

                    <h3>
                        {{ org_basic_data.school_name }}
                    </h3>

                    <h5>
                        {{ org_basic_data.address }}
                    </h5>

                    <h4>
                        Session : {{ ay }}
                    </h4>

                    <h4>
                        Semester : {{ semester }}
                    </h4>

                    <h4>
                        Standard : {{ standard }}
                    </h4>
                </div>

            </div>

            <div class="text-right mb-2">
                <v-btn small color="success" class="mr-2" @click="exportExcel">
                    Export Excel
                </v-btn>

                <v-btn small color="primary" @click="printReport">
                    Print
                </v-btn>
            </div>

            <div class="table-container">
                <v-simple-table dense fixed-header class="elevation-1">
                    <thead>
                        <tr>
                            <th>Subject</th>

                            <th class="text-center">
                                Registered Students
                            </th>

                            <th class="text-center">
                                Total Passed Students
                            </th>

                            <th class="text-center">
                                Total Failed Students
                            </th>

                            <th class="text-center">
                                Passed Avg (%)
                            </th>
                        </tr>
                    </thead>

                    <tbody v-for="(d, index) in report_list" :key="index">
                        <tr>
                            <td colspan="7" class="section-row">
                                SECTION : {{ d.division }}
                            </td>
                        </tr>

                        <tr v-for="(s, i) in d.subject_list" :key="i">
                            <td class="text-left">
                                {{ s.subject }}
                            </td>

                            <td>
                                {{ s.registered_count }}
                            </td>

                            <td>
                                {{ s.pass_count }}
                            </td>

                            <td>
                                {{ s.fail_count }}
                            </td>

                            <td>
                                {{ s.pass_per }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            status: "0",
            report_list: [],
            ay: "",
            semester: "",
            standard: "",
            status_list: [
                {
                    name: "Active",
                    id: "0"
                },
                {
                    name: "Temporary Inactive",
                    id: "1"
                },
                {
                    name: "Permanent Inactive",
                    id: "2"
                }
            ],
            org_basic_data: []
        };
    },

    methods: {

        showSnackbar(clr, msg) {

            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.semester_list = res.data.sem_list;
                })

                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },

        getDiv() {
            this.div_list = this.sel_std_data.div_list;
            this.div_list.unshift({
                div_name: "All",
                div_off_id: "All"
            });
            this.div =
                this.div_list[0].div_off_id;
        },

        getReport() {
            this.fetch_loader = true;
            this.report_list = [];
            let payload = {
                ay: this.sel_ay_data.ay_id,
                sem: this.sem,
                standard: this.sel_std_data.std_id,
                div: this.div,
                status: this.status
            };

            axios
                .post(
                    "/Examination/getSubjectWisePassFailAnalysis", payload)

                .then((res) => {
                    if (res.data.flag === "YES") {

                        this.report_list = res.data.report_list;
                        this.ay = res.data.ay;
                        this.semester = res.data.semester;
                        this.standard = res.data.standard;
                        this.org_basic_data = res.data.org_basic_data;
                    } else {
                        this.showSnackbar("#b71c1c", "No data found");
                    }
                })

                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong");
                })

                .finally(() => {
                    this.fetch_loader = false;
                });
        },

        printReport() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        exportExcel() {
            let data = [];
            this.report_list.forEach((d) => {
                data.push({
                    Subject: "SECTION : " + d.division
                });

                d.subject_list.forEach((s) => {

                    data.push({
                        Subject: s.subject,
                        Registered_Students: s.registered_count,
                        Passed_Students: s.pass_count,
                        Pass_Percentage: s.pass_per,
                        Failed_Students: s.fail_count,
                        Grace_Count: s.grace_count
                    });
                });
            });

            const worksheet = XLSX.utils.json_to_sheet(data);

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Subject Wise Report"
            );

            XLSX.writeFile(
                workbook,
                "Subject_Wise_Pass_Fail_Report.xlsx"
            );
        }
    },

    mounted() {
        this.onload();
    }
};
</script>

<style scoped>
.report-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 20px;
}

.logo-section {
    position: absolute;
    left: 0;
    top: 10px;
}

.school-logo {
    width: 120px;
    height: 120px;
    object-fit: contain;
}

.header-content {
    width: 100%;
}

.header-content h2,
.header-content h3,
.header-content h4,
.header-content h5 {
    margin: 3px 0;
}

.table-container {

    max-height: 800px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #ccc;
}

table,
tr,
td,
th {

    border: 1px solid #ccc;
    text-align: center;
}

td,
th {

    padding: 8px !important;
    font-size: 13px;
}

.section-row {

    background-color: #e0e0e0;
    font-weight: bold;
    text-align: left;
}

@media print {

    body {

        -webkit-print-color-adjust: exact;
    }

    .v-btn,
    .v-input,
    .v-autocomplete,
    .no-display,
    .v-snack {
        display: none !important;
    }

    table,
    tr,
    td,
    th {
        border: 1px solid black !important;
        font-size: 14px !important;
    }

    .section-row {
        background-color: #d3d3d3 !important;
    }

    .school-logo {
        width: 150px;
        height: 150px;
        object-fit: contain;
    }

    .table-container {
        max-height: none !important;
        overflow: visible !important;
    }

    @page {
        size: A4;
        margin: 10mm;
    }
}
</style>